import * as apiRoutes from "api/routes";
import Rate from "components/rate";
import dynamic from "next/dynamic";
import Image from "next/image";
import { addThumbnailPostfixToImageName } from "utils/general";
import CustomerRating from "./customer-rating";
import styles from "./index.module.scss";
import Link from "next/link";
const Special = dynamic(() => import("components/tag/special"))




export default function ImageAndData({ data: profile }) {

  const contractor = profile.data;


  return (
    <div className={styles.container__imageAndData}>
      <div className={styles.profile_wrapper}>
        <Image
          unoptimized
          src={
            contractor.user?.avatar
              ? apiRoutes.UPLOAD_BASE_URL +
              addThumbnailPostfixToImageName(contractor.user?.avatar)
              : "/images/media/NoImage.svg"
          }
          alt="تصویر پروفایل"
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles.info}>
        <div className={styles.infoMargin}>
          <div className={styles.name__info}>
            {contractor.level === 1 && (
              <Special className={styles.special_contractor__name} />
            )}
            {contractor?.user?.name ?? ""} {contractor?.user?.lastname ?? ""}
          </div>

          {contractor?.totalCommentsCount !== 0 && (
            <>
              <div className={styles.second_line__info + " flex align-i-center gap-5"}>
                <Rate rate={contractor?.totalCommentsStar?.toFixed(1)} />
                <Link href="#comments">{`(${contractor?.totalCommentsCount || 0} نظر)`}</Link>
              </div>
            </>
          )}

          <CustomerRating
            doneProjectsCount={contractor.doneProjectsCount}
            totalCommentsCount={contractor.totalCommentsCount}
            workInInstallments={contractor.workInInstallments}
          />
        </div>
        <div className={styles.borderLeft}></div>
      </div>
    </div >
  );
}
